import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    sellList: { sells: [], total: 0, pageSize: 0, error: null, loading: false },
    activeSell: { sell: null, error: null, loading: false },
    activeIGV: { igv: null, error: null, loading: false },
    itemList: { items: [], total: 0, error: null, loading: false},
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_SELLS:
            return {
                ...state,
                sellList: {
                    ...state.sellList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_SELLS_SUCCESS:
            return {
                ...state,
                sellList: {
                    sells: action.payload.sells,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_SELLS_FAILURE:
            return {
                ...state,
                sellList: {
                    sells: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_SELLS:
            return { ...state, sellList: initialState.sellList }


            case actionTypes.FETCH_ITEMS_LIST:
                return {
                    ...state,
                    itemList: {
                        ...state.itemList,
                        error: null,
                        loading: true
                    }
                }
    
            case actionTypes.FETCH_ITEMS_LIST_SUCCESS:
                return {
                    ...state,
                    itemList: {
                        items: action.payload.items,
                        total: action.payload.total,
                        // pageSize: action.payload.pageSize,
                        error: null,
                        loading: false
                    }
                }
    
            case actionTypes.FETCH_ITEMS_LIST_FAILURE:
                return {
                    ...state,
                    itemList: {
                        items: [],
                        total: 0,
                        // pageSize: 0,
                        error: action.payload.error,
                        loading: false
                    }
                }
    
            case actionTypes.RESET_ITEMS_LIST:
                return { ...state, itemList: initialState.itemList }

        case actionTypes.FETCH_SELL:
            return { ...state, activeSell: { sell: null, error: null, loading: true } }

        case actionTypes.FETCH_SELL_SUCCESS:
            return { ...state, activeSell: { sell: action.payload.sell, error: null, loading: false } }

        case actionTypes.FETCH_SELL_FAILURE:
            return { ...state, activeSell: { sell: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_SELL:
            return { ...state, activeSell: initialState.activeSell }


        case actionTypes.FETCH_IGV:
            return { ...state, activeIGV: { igv: null, error: null, loading: true } }

        case actionTypes.FETCH_IGV_SUCCESS:
            return { ...state, activeIGV: { igv: action.payload.igv, error: null, loading: false } }

        case actionTypes.FETCH_IGV_FAILURE:
            return { ...state, activeIGV: { igv: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_IGV:
            return { ...state, activeIGV: initialState.activeIGV }



        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/sell/reducer.js